



































































































































































































































































































import Vue, { PropType } from 'vue';
import moment from 'moment';
import {
  IPaymentRequisition,
  IPaymentRequisitionLine,
  PaymentRequisitionPaymentType,
  PaymentRequisitionStatusEnum
} from '@/models';
import { DataTableHeader } from 'vuetify';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import DetailOptionsButton from '@/components/common/DetailOptionsButton.vue';

export default mixins(auth).extend({
  name: 'PaymentRequisitionDetail',

  components: {
    DetailOptionsButton
  },

  props: {
    paymentRequisition: {
      type: Object as PropType<IPaymentRequisition>,
      required: true
    }
  },

  computed: {
    canEditAllRequisitionLine() {
      return (
        this.paymentRequisition.status.value ===
        PaymentRequisitionStatusEnum.Draft
      );
    },

    headers() {
      const baseHeaders: DataTableHeader[] = [
        {
          text: '#',
          value: 'index',
          width: 45,
          sortable: false,
          class: 'primary white--text subtitle-1'
        },
        {
          text: 'Item',
          value: 'item',
          width: 300,
          sortable: false,
          class: 'primary white--text subtitle-1'
        },

        {
          text: 'Account',
          value: 'account',
          width: 100,
          sortable: false,
          class: 'primary white--text subtitle-1'
        },
        {
          text: 'Department',
          value: 'department',
          sortable: false,
          width: 100,
          class: 'primary white--text subtitle-1'
        },
        {
          text: 'Amount',
          value: 'total_price',
          align: 'center',
          width: 100,
          sortable: false,
          class: 'primary white--text subtitle-1'
        }
      ];

      if (this.userHasRoles(['Finance Vice President'])) {
        baseHeaders.push({
          text: '',
          value: 'actions',
          align: 'center',
          width: 10,
          sortable: false,
          class: 'primary white--text subtitle-1'
        });
      }

      return baseHeaders;
    }
  },

  methods: {
    momentFormat(date: Date | string | number, days = 0) {
      return moment(date ?? new Date())
        .add(days, 'd')
        .format('LL')
        .toString();
    },

    genPaymentType(payment: number): string {
      switch (payment) {
        case PaymentRequisitionPaymentType.CASH:
          return 'Cash';
        case PaymentRequisitionPaymentType.CARD:
          return 'Card';
        case PaymentRequisitionPaymentType.CHEQUE:
          return 'Cheque';
        case PaymentRequisitionPaymentType.WIRE:
          return 'Wire';
        default:
          return '-'; //default display value
      }
    },

    editPaymentRequisitionLine(item: IPaymentRequisitionLine) {
      this.$emit('edit-requisition-line', item);
    }
  }
});
